(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('SectorService', SectorService)

  SectorService.$inject = ['$resource']
  function SectorService ($resource) {
    return $resource(apiUrl + '/companies/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { url: apiUrl + '/companies/:id/sectors', method: 'POST', params: {}, isArray: false },
      update: { url: apiUrl + '/companies/:id/sectors', method: 'POST', params: {}, isArray: true },
      remove: { url: apiUrl + '/companies/:company_id/sectors/:id', method: 'DELETE', params: {}, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      loadUsersBySector: { url: apiUrl + '/users-by-sector', params: {}, isArray: false },
      loadSectorsByUser: { url: apiUrl + '/sectors-by-user', params: {}, isArray: true },
      sectors_with_trashed: { url: apiUrl + '/sectors-with-trashed', method: 'GET', isArray: true },
      loadSectorsByCompany: { url: apiUrl + '/sectors-by-company', params: {}, isArray: false },
      loadSectorsTransferByUser: { url: apiUrl + '/sectors-transfer-by-user', params: {}, isArray: true }
    })
  }
})();
